/** Local transport outcome, not an API response DTO. */
export class SupportSubmissionRejection extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'SupportSubmissionRejection';
  }
}

function record(value: unknown): Record<string, unknown> | undefined {
  return typeof value === 'object' && value !== null
    ? (value as Record<string, unknown>)
    : undefined;
}

/** Only responses that prove this POST was rejected before Front submission unlock editing. */
export function submissionRejection(error: unknown): SupportSubmissionRejection | null {
  const outer = record(error);
  if (!outer) return null;
  const normalized = record(outer.data);
  // auth0BaseQuery normalizes network failures to numeric HTTP-like statuses.
  if (normalized?.failureClass && normalized.failureClass !== 'http') return null;
  let message: string;
  switch (outer.status) {
    case 400:
    case 422:
      message =
        'Check your message, screenshot, and account reply email. Screenshots must be PNG, JPEG, or WebP, up to 3 MB.';
      break;
    case 401:
      message = 'Your session has expired. Copy your message, sign in again, then try again.';
      break;
    case 403:
      message = 'We couldn’t authorize this request. Contact support@jotpsych.com for help.';
      break;
    case 413:
      message = 'Your screenshot is too large. Remove it or choose one up to 3 MB, then try again.';
      break;
    case 429:
      message =
        'You’ve reached the support request limit. Your draft is saved here. Try again later.';
      break;
    case 503:
      // Only the server's allowlisted pre-send code distinguishes this from a proxy 503.
      if ((record(normalized?.data) ?? normalized)?.error_code !== 'support_unavailable')
        return null;
      message =
        'Support is temporarily unavailable. Try again later or email support@jotpsych.com.';
      break;
    default:
      return null;
  }
  return new SupportSubmissionRejection(message);
}
